import React from 'react';

import DialogCore, { Props } from '@travel/traveler-core/components/Dialog';

function Dialog(props: Props) {
  return <DialogCore {...props} />;
}

export default Dialog;
